import PaginationCustom from './Pagination';
export default PaginationCustom;